import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import Popover from '@material-ui/core/Popover'
import { makeStyles, Grid, Button } from '@material-ui/core'
import NotificationsSummary from './notificationsSummary'
import NotificationsConfig from './notificationsConfig'
import clsx from 'clsx'

const NotificationsSummaryPopover = ({
   anchorEl,
   setAnchorEl,
   notificationsConfigs,
   setNotificationsConfigs,
   history
}) => {
   const open = Boolean(anchorEl)
   const id = open ? 'simple-popover' : undefined

   function handleClose() {
      setAnchorEl(null)
   }

   function goToAllNotifications() {
      history.push('/dashboard/notifications')
      setAnchorEl(null)
   }

   return (
      <Popover
         id={id}
         open={open}
         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
         transformOrigin={{ vertical: 'top', horizontal: 'right' }}
         anchorEl={anchorEl}
         onClose={handleClose}
      >
         <NotificationsSummaryContainer
            notificationsConfigs={notificationsConfigs}
            setNotificationsConfigs={setNotificationsConfigs}
            goToAllNotifications={goToAllNotifications}
         />
      </Popover>
   )
}

export default withRouter(NotificationsSummaryPopover)

// ------------------------------------------------------

const useNotificationsSummaryContainerStyles = makeStyles(() => ({
   popoverContent: {
      width: 340,
      maxHeight: 500,
      display: 'flex',
      flexDirection: 'column'
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 8
   },
   body: {
      flex: '1 1 auto',
      overflowY: 'auto',
      overflowX: 'hidden'
   },
   footer: {
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'flex-end'
   },
   button: {
      font: 'normal normal bold 12px/16px Roboto'
   },
   active: {
      color: '#3264DC'
   }
}))

const NotificationsSummaryContainer = ({
   notificationsConfigs,
   setNotificationsConfigs,
   goToAllNotifications
}) => {
   const [tabsValue, setTabsValue] = useState(0)
   const classes = useNotificationsSummaryContainerStyles()

   function showNotifications() {
      setTabsValue(0)
   }

   function showConfiguration() {
      setTabsValue(1)
   }

   return (
      <Grid className={classes.popoverContent}>
         <Grid value={tabsValue} className={classes.header}>
            <Button
               className={clsx(classes.button, {
                  [classes.active]: tabsValue === 0
               })}
               onClick={showNotifications}
            >
               Notificaciones
            </Button>
            {notificationsConfigs && (
               <Button
                  className={clsx(classes.button, {
                     [classes.active]: tabsValue === 1
                  })}
                  onClick={showConfiguration}
               >
                  CONFIGURACIÓN
               </Button>
            )}
         </Grid>
         <Grid className={classes.body}>
            {tabsValue === 0 && <NotificationsSummary />}
            {tabsValue === 1 && notificationsConfigs && (
               <NotificationsConfig
                  notificationsConfigs={notificationsConfigs}
                  setNotificationsConfigs={setNotificationsConfigs}
               />
            )}
         </Grid>
         <Grid className={classes.footer}>
            <Button
               onClick={goToAllNotifications}
               className={`${classes.button} ${classes.active}`}
            >
               VER TODAS
            </Button>
         </Grid>
      </Grid>
   )
}
